<p>supplier-logos works!</p>
